import React from 'react';

export default () => {
	return <div className="capacity-overview-scheduling-top-left"></div>;
};
